import type { Range } from '@attain-apps/range'

import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Trends',
      type: 'charts',
      content: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'piSwitch',
                },
                true,
              ],
            },
            {
              '{}': {
                data: {
                  '[]': [
                    {
                      '{}': {
                        name: {
                          '++': [
                            {
                              '@$': 'financialVolume',
                            },
                            ' Performance',
                          ],
                        },
                        values: {
                          '@': 'piGroup',
                        },
                      },
                    },
                  ],
                },
                type: 'bar.stacked',
              },
            },
          ],
          {
            '{}': {
              data: {
                '[]': [
                  {
                    '{}': {
                      name: {
                        '++': [
                          {
                            '@$': 'financialVolume',
                          },
                          ' Performance',
                        ],
                      },
                      values: {
                        '@': 'organizationGroup',
                      },
                    },
                  },
                ],
              },
              type: 'bar.stacked',
            },
          },
        ],
      },
    },
  },
  variables: {
    piSwitch: false,
  },
  subqueries: {
    piGroup: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              null,
            ],
          },
          {
            in: [
              {
                '[]': [
                  {
                    '@$': 'orgRecordId',
                  },
                ],
              },
              {
                '@': 'projectOrgs',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          points: {
            '[]': [
              {
                '{}': {
                  x: '2020',
                  y: {
                    '+': {
                      '@': 'expenses2020',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2021',
                  y: {
                    '+': {
                      '@': 'expenses2021',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2022',
                  y: {
                    '+': {
                      '@': 'expenses2022',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2023',
                  y: {
                    '+': {
                      '@': 'expenses2023',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2024',
                  y: {
                    '+': {
                      '@': 'expenses2024',
                    },
                  },
                },
              },
            ],
          },
        },
      },
      subqueries: {
        projects: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'projectPiAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@.': [
                      '!org',
                      {
                        ref: {
                          entity: 'ent:!org:!dept',
                        },
                      },
                    ],
                  },
                  {
                    '@$': 'orgRecordId',
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
        },
        projectOrgs: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'projectPiAssignments',
          filter: {
            '!=': [
              {
                '@': 'organizations',
              },
              {
                '[]': [],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@': 'organizations',
          },
          subqueries: {
            organizations: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'dim::!org',
              selection: {
                '@.': '!id',
              },
            },
          },
        },
        expenses2020: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2020',
              },
              start: {
                $date: '1/1/2020',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2021: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2021',
              },
              start: {
                $date: '1/1/2021',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2022: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2022',
              },
              start: {
                $date: '1/1/2022',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2023: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2023',
              },
              start: {
                $date: '1/1/2023',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2024: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2024',
              },
              start: {
                $date: '1/1/2024',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        projectPiAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    organizationGroup: {
      filter: {
        '=': [
          {
            '@^': 'parent',
          },
          {
            '@$': 'orgRecordId',
          },
        ],
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          points: {
            '[]': [
              {
                '{}': {
                  x: '2020',
                  y: {
                    '+': {
                      '@': 'expenses2020',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2021',
                  y: {
                    '+': {
                      '@': 'expenses2021',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2022',
                  y: {
                    '+': {
                      '@': 'expenses2022',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2023',
                  y: {
                    '+': {
                      '@': 'expenses2023',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2024',
                  y: {
                    '+': {
                      '@': 'expenses2024',
                    },
                  },
                },
              },
            ],
          },
        },
      },
      subqueries: {
        expenses2020: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2020',
              },
              start: {
                $date: '1/1/2020',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2021: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2021',
              },
              start: {
                $date: '1/1/2021',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2022: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2022',
              },
              start: {
                $date: '1/1/2022',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2023: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2023',
              },
              start: {
                $date: '1/1/2023',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        expenses2024: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'financialVolume',
                    },
                    'MTDC',
                  ],
                },
                {
                  '=': [
                    {
                      '@': 'costType',
                    },
                    'MTDC',
                  ],
                },
              ],
              {
                '=': [
                  {
                    '@': 'costType',
                  },
                  'TDC',
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2024',
              },
              start: {
                $date: '1/1/2024',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!code',
              },
            },
          },
        },
        projectAssignments: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          target: 'ent:!projects:!proj',
        },
      },
    },
  },
}
